import { z } from 'zod';
import { ActionTypeSchema } from './actionTypes';
import { ClientDataSchema } from '../clientState';
export var ClientKeySchema = z.enum([
    'email',
    'loggedIn',
    'activationCode',
    'score_data',
    'STRIPE_CUSTOMER_PORTAL_URL'
]);
var setEmailSchema = z.object({
    type: ActionTypeSchema.extract(['SET_CLIENT_KEY']),
    key: ClientKeySchema.extract(['email']),
    value: z.string().or(z.null())
});
var setLoggedInSchema = z.object({
    type: ActionTypeSchema.extract(['SET_CLIENT_KEY']),
    key: ClientKeySchema.extract(['loggedIn']),
    value: z.boolean()
});
var setActivationCodeSchema = z.object({
    type: ActionTypeSchema.extract(['SET_CLIENT_KEY']),
    key: ClientKeySchema.extract(['activationCode']),
    value: z.string()
});
var setScoreDataKeySchema = z.object({
    type: ActionTypeSchema.extract(['SET_CLIENT_KEY']),
    key: ClientKeySchema.extract(['score_data']),
    value: z.object({
        products: z.record(z.string(), z.number()),
        memo: z.string()
    })
});
var setStripeCustomerPortalUrlSchema = z.object({
    type: ActionTypeSchema.extract(['SET_CLIENT_KEY']),
    key: ClientKeySchema.extract(['STRIPE_CUSTOMER_PORTAL_URL']),
    value: z.string()
});
export var setClientKeyActionSchema = z.discriminatedUnion('key', [
    setEmailSchema,
    setLoggedInSchema,
    setActivationCodeSchema,
    setScoreDataKeySchema,
    setStripeCustomerPortalUrlSchema
]);
export var deleteClientKeyActionSchema = z.object({
    type: ActionTypeSchema.extract(['DELETE_CLIENT_KEY']),
    key: ClientDataSchema.keyof()
});
export var updateClientStoreActionSchema = z.object({
    type: ActionTypeSchema.extract(['UPDATE_CLIENT_STORE']),
    data: ClientDataSchema.partial()
});
